<template>
  <b-modal
    v-model="showModal"
    title="POB Details"
    size="xl"
    @hidden="$emit('modal-closed')"
  >
    <b-alert
      variant="danger"
      :show="errorMessage ? true : false"
    >
      <div
        v-if="typeof errorMessage === 'object'"
        class="alert-body"
      >
        <p
          v-for="(message, index) in errorMessage"
          :key="index"
        >
          {{ message }}
        </p>
      </div>
      <p
        v-else
        class="alert-body"
      >
        {{ errorMessage }}
      </p>
    </b-alert>

    <div
      v-if="loading"
      class="text-center"
    >
      <b-spinner
        label="Small Spinner"
        variant="primary"
      />
    </div>
    <div v-if="!loading && !errorMessage">
      <!-- Basic POB Information -->
      <b-table-simple
        responsive
        hover
        class="compact-table mb-2 basic-info-table"
      >
        <b-tbody>
          <b-tr>
            <b-th>
              POB Number:
            </b-th>
            <b-td>{{ details.pob_number }}</b-td>
            <b-th>
              Status:
            </b-th>
            <b-td>
              <app-chip :variant="getStausChipVariant(details.status)">
                {{ details.status.charAt(0).toUpperCase() + details.status.slice(1) }}
              </app-chip>
            </b-td>
            <b-th>
              POB Mode:
            </b-th>
            <b-td>{{ details.pob_mode || '-' }}</b-td>
          </b-tr>
          <b-tr>
            <b-th class="nowrap-header">
              Company:
            </b-th>
            <b-td
              class="company-cell"
            >
              {{ details.company_name }}
            </b-td>
            <b-th class="nowrap-header">
              Created By:
            </b-th>
            <b-td>{{ details.created_by_fullname }}</b-td>
            <b-th class="nowrap-header">
              Created At:
            </b-th>
            <b-td>
              {{ details.created_at && formatedDate(details.created_at, 'DD-MM-YYYY LT') || '-' }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th class="nowrap-header">
              Party:
            </b-th>
            <b-td
              class="party-cell"
            >
              {{ details.party_name }}
            </b-td>
            <b-th
              class="nowrap-header"
            >
              Placed By:
            </b-th>
            <b-td>
              {{ details.placed_by_fullname || '-' }}
            </b-td>
            <b-th class="nowrap-header">
              Placed At:
            </b-th>
            <b-td>
              {{ details.placed_at && formatedDate(details.placed_at, 'DD-MM-YYYY LT') || '-' }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th
              v-if="details.pob_file"
              class="nowrap-header"
            >
              POB File:
            </b-th>
            <b-td
              v-if="details.pob_file"
              colspan="3"
            >
              <a
                :href="details.pob_file"
                target="_blank"
                class="text-primary"
              >
                View POB File
              </a>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <!-- MR Information -->
      <div
        v-if="details.mr && details.mr.length > 0"
        class="mb-2"
      >
        <h5>Medical Representatives</h5>
        <b-table-simple
          responsive
          hover
          class="compact-table"
        >
          <b-thead>
            <b-tr>
              <b-th>MR Name</b-th>
              <b-th>Primary Mobile</b-th>
              <b-th>WhatsApp</b-th>
              <b-th>Primary Email</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr
              v-for="mr in details.mr"
              :key="mr.id"
            >
              <b-td>{{ mr.name }}</b-td>
              <b-td>
                {{ (mr.mr_mobiles.find(mobile => mobile.is_primary) && mr.mr_mobiles.find(mobile => mobile.is_primary).mobile) || '-' }}
              </b-td>
              <b-td>
                <span v-if="mr.mr_mobiles.find(mobile => mobile.is_whatsapp)">
                  {{ mr.mr_mobiles.find(mobile => mobile.is_whatsapp).mobile || '-' }}
                </span>
                <span v-else>N/A</span>
              </b-td>
              <b-td>
                {{ (mr.mr_emails.find(email => email.is_primary) && mr.mr_emails.find(email => email.is_primary).email) || '-' }}
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
      <!-- POB Items -->
      <div
        v-if="details.pob_items && details.pob_items.length > 0"
        class="mb-2"
      >
        <h5>POB Items</h5>
        <b-table-simple
          responsive
          hover
          class="compact-table pob-items-table"
        >
          <b-thead>
            <b-tr>
              <b-th>Product</b-th>
              <b-th>Qty</b-th>
              <b-th>Approved Qty</b-th>
              <b-th>Free Qty</b-th>
              <b-th>Approved Free Qty</b-th>
              <b-th>Rate</b-th>
              <b-th>Total</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr
              v-for="item in details.pob_items"
              :key="item.id"
            >
              <b-td>{{ item.product }}</b-td>
              <b-td>{{ item.quantity }}</b-td>
              <b-td>{{ item.approved_quantity || '-' }}</b-td>
              <b-td>{{ item.free_quantity || 0 }}</b-td>
              <b-td>{{ item.approved_free_quantity || 0 }}</b-td>
              <b-td>₹{{ item.rate }}</b-td>
              <b-td>₹{{ (item.quantity * item.rate).toFixed(2) }}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
      <div
        v-if="details.order"
        class="mb-2 border-primary px-1 py-1 rounded"
      >
        <h5>Order Details</h5>
        <pob-order-details
          :data="details.order"
        />
      </div>
      <!-- POB Remarks -->
      <div v-if="details.pob_remarks && details.pob_remarks.length > 0">
        <h5>Remarks History</h5>
        <div class="remarks-container">
          <div
            v-for="remark in sortedRemarks"
            :key="remark.id"
            class="remark-item my-1"
            :class="getRemarkBorderClass(remark.type)"
          >
            <strong>{{ remark.created_by_fullname }}</strong>
            <small class="text-muted"> - {{ remark.created_at && formatedDate(remark.created_at, 'DD-MM-YYYY LT') }}</small>
            <div class="text-primary">
              {{ remark.remarks }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <template #modal-footer="{ ok, cancel }">
      <b-button
        variant="secondary"
        @click="cancel()"
      >
        Close
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal, BSpinner, BButton, BAlert, BTableSimple, BTr, BTh, BTd, BTbody, BThead,
} from 'bootstrap-vue'
import axios from 'axios'
import dateMixin from '@/mixins/dateMixin'
import AppChip from '../../UI/AppChip.vue'
import PobOrderDetails from './PobOrderDetails.vue'

export default {
  components: {
    BModal,
    BButton,
    BSpinner,
    BAlert,
    BTableSimple,
    BTr,
    BTh,
    AppChip,
    BTd,
    BTbody,
    BThead,
    PobOrderDetails,
  },
  mixins: [dateMixin],
  props: {
    id: { type: Number, required: true },
  },
  data() {
    return {
      showModal: true,
      details: {},
      loading: true,
      errorMessage: '',
      readOnly: false,
    }
  },
  computed: {
    sortedRemarks() {
      if (!this.details.pob_remarks) return []
      return [...this.details.pob_remarks].sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    },
  },
  mounted() {
    this.fetchDetails()
  },
  methods: {
    async fetchDetails() {
      try {
        this.loading = true
        const { data } = await axios.get(`/marg/pobs/${this.id}`)
        this.details = data
      } catch (error) {
        this.errorMessage = error?.response?.data?.detail || 'Failed to fetch details'
      } finally {
        this.loading = false
      }
    },
    async addRemark() {
      if (!this.newRemark.trim()) return

      try {
        this.addingRemark = true
        const { data } = await axios.post(`/marg/pobs/${this.id}/remarks`, {
          remarks: this.newRemark.trim(),
        })

        // Add the new remark to the local data
        if (!this.details.pob_remarks) {
          this.details.pob_remarks = []
        }
        this.details.pob_remarks.push(data)
        this.newRemark = ''
      } catch (error) {
        this.errorMessage = error?.response?.data?.detail || 'Failed to add remark'
      } finally {
        this.addingRemark = false
      }
    },
    getStausChipVariant(value) {
      if (value === 'rejected') {
        return 'danger'
      }
      if (value === 'pending') {
        return 'warning'
      }
      if (value === 'fully approved' || value === 'partially approved' || value === 're-approved') {
        return 'success'
      }
      if (value === 'security') {
        return 'primary'
      }

      return 'secondary'
    },
    getRemarkBorderClass(remarkType) {
      if (remarkType === 'rejection') {
        return 'remark-rejection'
      }
      if (remarkType === 'approval' || remarkType === 'partial approval' || remarkType === 're-approval') {
        return 'remark-approval'
      }
      return 'remark-other'
    },
  },
}
</script>

<style scoped>
label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
}

td {
  text-align: start;
}

th {
  width: auto;
  margin: 0;
  padding: 10px 15px;
  white-space: nowrap;
}

.compact-table th,
.compact-table td {
  padding: 10px 15px;
  vertical-align: middle;
}

/* Basic Information Table - Optimized for XL modal */
.basic-info-table th {
  width: 12%;
  min-width: 120px;
}

.basic-info-table td {
  width: 21%;
  min-width: 140px;
}

/* Fix for header text wrapping */
.nowrap-header {
  white-space: nowrap;
  min-width: max-content;
}

/* Company and Party cell adjustments */
.company-cell,
.party-cell {
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  padding: 12px 15px;
  font-weight: 500;
}

/* POB Items Table - Better column distribution for XL modal */
.pob-items-table th:nth-child(1), /* Product */
.pob-items-table td:nth-child(1) {
  width: 35%;
  min-width: 200px;
}

.pob-items-table th:nth-child(2), /* Qty */
.pob-items-table td:nth-child(2) {
  width: 8%;
  min-width: 60px;
  text-align: center;
}

.pob-items-table th:nth-child(3), /* Appr. Qty */
.pob-items-table td:nth-child(3) {
  width: 10%;
  min-width: 80px;
  text-align: center;
}

.pob-items-table th:nth-child(4), /* Free Qty */
.pob-items-table td:nth-child(4) {
  width: 9%;
  min-width: 70px;
  text-align: center;
}

.pob-items-table th:nth-child(5), /* Appr. Free Qty */
.pob-items-table td:nth-child(5) {
  width: 12%;
  min-width: 100px;
  text-align: center;
}

.pob-items-table th:nth-child(6), /* Rate */
.pob-items-table td:nth-child(6) {
  width: 13%;
  min-width: 100px;
  text-align: right;
}

.pob-items-table th:nth-child(7), /* Total */
.pob-items-table td:nth-child(7) {
  width: 13%;
  min-width: 100px;
  text-align: right;
  font-weight: 600;
}

/* Remove fixed table layout for better space utilization */
.compact-table {
  width: 100%;
  table-layout: auto;
}

.remarks-container {
  max-height: 200px;
  overflow-y: auto;
}

.remark-item {
  border-bottom: 1px solid #e9ecef;
  padding: 8px 12px;
  border-radius: 4px;
  margin-bottom: 8px;
}

.remark-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

/* Remark border colors based on type */
.remark-rejection {
  border-left: 4px solid #dc3545;
  background-color: #f8d7da20;
}

.remark-approval {
  border-left: 4px solid #28a745;
  background-color: #d4edda20;
}

.remark-other {
  border-left: 4px solid #6c757d;
  background-color: #f8f9fa;
}

h5 {
  color: #495057;
  font-weight: 600;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e9ecef;
}

/* Responsive adjustments */
@media (max-width: 1200px) {
  .basic-info-table th {
    width: 15%;
    min-width: 100px;
  }

  .basic-info-table td {
    width: 18%;
    min-width: 120px;
  }

  .pob-items-table th:nth-child(1),
  .pob-items-table td:nth-child(1) {
    width: 30%;
    min-width: 150px;
  }
}

@media (max-width: 768px) {
  .compact-table th,
  .compact-table td {
    padding: 6px 8px;
    font-size: 0.9rem;
  }

  .compact-table {
    font-size: 0.85rem;
  }

  .nowrap-header {
    font-size: 0.8rem;
  }

  /* Stack basic info vertically on mobile */
  .basic-info-table th,
  .basic-info-table td {
    width: auto;
    min-width: auto;
  }

  /* Adjust POB items table for mobile */
  .pob-items-table th,
  .pob-items-table td {
    min-width: 60px;
    font-size: 0.8rem;
  }
}
</style>
